<template>
  <div class="or-divider">
    <span class="or-divider__text">or</span>
  </div>
</template>

<script>
export default {
  name: 'OrDivider',
};
</script>

<docs>

A divider used to vertically separate 2 options with the word 'or'.

</docs>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_or-divider';
</style>
